export enum ChipPaperType {
  'SELECT' = 'SELECT',
  'CHECKBOX_LIST' = 'CHECKBOX_LIST',
  'CHECKBOX_LIST_TOGGLE' = 'CHECKBOX_LIST_TOGGLE',
  'FACE_CHECKBOX_LIST' = 'FACE_CHECKBOX_LIST'
}

export enum CharacterNumberInputType {
  'SELECT' = 'SELECT', //character number를 반드시 지정해야 함
  'CHIP' = 'CHIP' //character number가 optional한 값임
}
